import countryData from "../data/COUNTRY_DATA";
import getSpellingDifference from "./getSpellingDifference";
import { ACCEPTED_COUNTRY_CODES } from "../data/ACCEPTED_COUNTRY_CODES";

export const sortByName = (countries) => {
  return countries.sort((a, b) => a.name.localeCompare(b.name));
};

export const filterByRegion = (countryData, region = "World") => {
  return region === "World"
    ? countryData
    : countryData.filter((country) => country.region === region);
};

export const filterSmallCountries = (countryData) => {
  const MINIMUM_SIZE = 10000;
  return countryData.filter((country) => country.area >= MINIMUM_SIZE);
};

export const shuffleArray = (array) => {
  let currentIdx = array.length;
  let randomIdx;
  while (currentIdx !== 0) {
    randomIdx = Math.floor(Math.random() * currentIdx);
    currentIdx--;
    [array[currentIdx], array[randomIdx]] = [
      array[randomIdx],
      array[currentIdx],
    ];
  }

  return array;
};

export const getMultipleChoiceOptions = (country, countryList) => {
  if (countryList.length === 197) {
    countryList = countryList.filter((c) => c.region === country.region);
  }
  let choices = [{ ...country, correct: true }];
  let options = countryList.filter((c) => c.name !== country.name);
  for (let i = 1; i < 4; i++) {
    let randomIdx = Math.floor(Math.random() * options.length);
    choices[i] = options[randomIdx];
    options.splice(randomIdx, 1);
  }

  return shuffleArray(choices);
};

export const formatNumber = (number) => {
  let formattedNumber = [];
  String(number)
    .split("")
    .reverse()
    .forEach((digit, idx) => {
      if (idx % 3 === 0 && idx !== 0 && number % 1 === 0) {
        formattedNumber.push(",");
      }
      formattedNumber.push(digit);
    });
  return formattedNumber.reverse().join("");
};

export const getTimeDisplay = (time) => {
  let minutes = Math.floor(time / 60);
  let seconds = time - minutes * 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};

export const cleanInputValue = (value) => {
  return value
    .replace(/^ /g, "")
    .replace(/ +/g, " ")
    .replace(/-+/g, "-")
    .replace(/[^a-zA-Z -]/g, "")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const isCorrectAnswer = (inputValue, country, gameTitle) => {
  const MAX_SPELLING_DIFFERENCE = inputValue.length < 10 ? 0 : 1;
  let answers = ["Flags", "Lists"].includes(gameTitle)
    ? [country.name, ...country.otherNames]
    : [country.capital, ...country.otherCapitals];

  for (let answer of answers) {
    if (getSpellingDifference(inputValue, answer) <= MAX_SPELLING_DIFFERENCE) {
      return true;
    }
  }
  return false;
};

export const configureCountryData = (data) => {
  data = [...data].filter((country) =>
    ACCEPTED_COUNTRY_CODES.includes(country.cca2)
  );

  return data.map((country) => {
    let density = Math.round(country.population / country.area);

    return {
      name: country.name.common,
      otherNames: [
        ...country.altSpellings.slice(1),
        ...countryData.find((c) => c.code === country.cca2).otherNames,
      ],
      code: country.cca2,
      capital: country.capital[0],
      otherCapitals:
        country.capital.length === 1
          ? []
          : [
              ...country.capital.slice(1),
              ...countryData.find((c) => c.code === country.cca2).otherCapitals,
            ],
      region: country.region,
      flag: country.flags.png,
      area: country.area,
      population: country.population,
      borders: country.borders,
      landlocked: country.landlocked,
      density,
    };
  });
};

export const sortCountriesBy = (countryData, category) => {
  if (category === "Countries") {
    return sortByName(countryData);
  }
  const sortRules = {
    "Largest Populations": {
      sortRule: "population",
      sortDirection: "desc",
    },
    "Largest Areas": { sortRule: "area", sortDirection: "desc" },
    "Largest Densities": { sortRule: "density", sortDirection: "desc" },
    "Smallest Populations": {
      sortRule: "population",
      sortDirection: "asc",
    },
    "Smallest Areas": { sortRule: "area", sortDirection: "asc" },
    "Smallest Densities": { sortRule: "density", sortDirection: "asc" },
  };

  let sortRule = sortRules[category].sortRule;
  let sortDirection = sortRules[category].sortDirection;

  let sortedCountries = countryData.sort((a, b) => b[sortRule] - a[sortRule]);
  return sortDirection === "desc" ? sortedCountries : sortedCountries.reverse();
};
